import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import ElementUI from "element-ui";
import locale from "element-ui/lib/locale/lang/zh-TW";
import axios from "axios";
import store from "@/store";
import pdf from "vue-pdf";
import clipboard from "clipboard";
import "element-ui/lib/theme-chalk/index.css";
import getDay from "./filter/timestamp";
import addcomma from "./filter/addcomma";
import datechange from "./filter/datechange";
import FormatterPlugin from "@/plugins/formatters";

// editor
import VueQuillEditor from "vue-quill-editor";
// require editor styles
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

Vue.use(FormatterPlugin); // 全域註冊格式化函數，可用 this.$functionName 或 Vue.filter('functionName')
Vue.use(VueQuillEditor);
Vue.filter("getDay", getDay); //過濾時間的星期
Vue.filter("addcomma", addcomma); //全域金額加逗點
Vue.filter("datechange", datechange); //全域日期轉民國
// 全域mixin
import {
    errorHandlerMixin,
    AxiosMixin,
    HandlerMixin,
} from "@/assets/lib/commonMixin.js";
Vue.mixin(errorHandlerMixin);
Vue.mixin(AxiosMixin);
Vue.mixin(HandlerMixin);
Vue.prototype.clipboard = clipboard;

//全域的金額加逗號(3個位數)
Vue.prototype.$addcomma = addcomma;

// pdf預覽套件
Vue.use(pdf);

// 行事曆
import FullCalendar from "vue-full-calendar";
import "fullcalendar/dist/fullcalendar.css";
Vue.use(FullCalendar);

// 多層select加multi
import EleMultiCascader from "ele-multi-cascader";
import "ele-multi-cascader/dist/cascader.css";
Vue.use(EleMultiCascader);

locale.el.pagination.total = "共 {total} 筆";
locale.el.pagination.pagesize = "筆/頁";

// 封裝axios
Vue.prototype.$http = axios;

// 使用ElementUI元件繁體中文
Vue.use(ElementUI, {
    locale,
});

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount("#app");

router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title;
    } else {
        document.title = "中華民國儲蓄互助協會 簿記系統";
    }
    if (to.meta.title == '儲互社加保申請名冊管理') {
        // 協會 安基 共用元件不同type 改變不同麵包屑
        let breadcrumbList = {
            plus: "儲互社加保申請名冊",
            pass: "儲互社加保申請通過名單",
            fail: "儲互社加保申請不通過名單",
            add: "儲互社加保申請補件名單",
            quit: "儲互社退保申請名冊",
            modify: "儲互社資料變更申請名冊"
        }
        to.meta.breadcrumb = breadcrumbList[to.query.type]

    }
    next();
});
router.afterEach(to => {
    if (to.meta.changeBreadcrumb) {
        to.meta.breadcrumb = to.query.name || to.meta.breadcrumb;
    }

})